import { render, staticRenderFns } from "./ApprovedSubjects.vue?vue&type=template&id=68d3eb56&scoped=true"
import script from "./ApprovedSubjects.vue?vue&type=script&lang=js"
export * from "./ApprovedSubjects.vue?vue&type=script&lang=js"
import style0 from "./ApprovedSubjects.vue?vue&type=style&index=0&id=68d3eb56&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3eb56",
  null
  
)

export default component.exports